import React, {useState, useEffect} from 'react';
import Get from '../components/Get';
import color from '../components/color';
import {Menu} from '@mui/material';
import MoreBottomTab from '../MoreBottomTab';

const PlayHistory = () => {
  const [rows, setRows] = useState(null);

  const get = async () => {
    try {
      const res = await Get.PlayHistory('');
      console.log('PlayHistory Response:', res);

      if (res.data && Array.isArray(res.data) && res.data.length > 0) {
        const mappedRows = res.data.flatMap(section =>
          section.data.map((item, index) => {
            let number = item.fk_number_id;
            if (item.fk_number_id < 10 && item.type === 'j') {
              number = '0' + item.fk_number_id;
            }

            return (
              <div style={styles.cardRow} key={section.title + index}>
                <div style={styles.rowTop}>
                  <span style={styles.gameName}>
                    {item?.game?.name?.name ?? 'Unknown Game'}
                  </span>
                  <span style={styles.dateText}>{section.title}</span>
                </div>
                <div style={styles.rowBottom}>
                  <span style={styles.valueText}>No: {number}</span>
                  <span style={styles.valueText}>Type: {item.type}</span>
                  <span style={styles.amountText}>-{item.amount}</span>
                </div>
              </div>
            );
          }),
        );

        setRows(mappedRows);
      } else {
        setRows(
          <div style={{textAlign: 'center', marginTop: '50px'}}>
            <p>No Play History Available</p>
          </div>,
        );
      }
    } catch (err) {
      console.error('PlayHistory Fetch Error:', err);
    }
  };

  useEffect(() => {
    get();
  }, []);

  return (
    <>
      <div style={styles.headerBar}>
        <h2 style={styles.headerTitle}>My Play Game History</h2>
      </div>
      <div style={{padding: '16px', overflowY: 'auto', minHeight: '90vh'}}>
        {rows}
      </div>
      <MoreBottomTab />
    </>
  );
};

export default PlayHistory;

const styles = {
  headerBar: {
    height: '60px',
    backgroundColor: '#00318bff',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderBottomLeftRadius: '20px',
    borderBottomRightRadius: '20px',
    boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
  },
  headerTitle: {
    fontSize: '18px',
    fontWeight: 'bold',
    color: '#fff',
    margin: 0,
  },
  cardRow: {
    backgroundColor: 'rgba(29, 185, 120, 0.41)',
    margin: '16px',
    padding: '16px',
    borderRadius: '12px',
  },
  rowTop: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '8px',
  },
  gameName: {
    fontSize: '16px',
    fontWeight: 'bold',
    color: '#333',
  },
  dateText: {
    fontSize: '12px',
    color: '#888',
  },
  rowBottom: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  valueText: {
    fontSize: '14px',
    color: '#444',
  },
  amountText: {
    fontSize: '14px',
    fontWeight: 'bold',
    color: '#D9534F',
  },
};
